<template>
    <v-btn class="disabled" icon style="marginLeft: -10px;" @click="activateAnimation">
      <v-img alt='Logo!' id="logo" contain :src="require('@/assets/logo-symbol-white.svg')" max-width="40px"/>
    </v-btn>
</template>

<script>

export default {
  name: 'TopLeftButtons',
  data () {
    return {
      animationActive: false,
      idleTime: 600000
    }
  },
  methods: {
    logo () {
      return document.querySelector('#logo')
    },
    activateAnimation () {
      this.animationActive = true
      if (!this.logo().classList.contains('animating-logo')) this.logo().classList.add('animating-logo')
    },
    resetTimer () {
      this.animationActive = false
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.activateAnimation(), this.idleTime)
    }
  },
  mounted () {
    window.onload = this.resetTimer
    window.onmousemove = this.resetTimer
    this.logo().addEventListener('animationiteration', () => {
      if (!this.animationActive) this.logo().classList.remove('animating-logo')
    })
  }
}
</script>
